import React from 'react';
import { HeaderTabItem } from '@vtblife/layout-config/types';

import { DropdownMenu } from '../dropdown-menu/dropdown-menu';
import { MenuItem } from '../menu-item/menu-item';

export interface MenuItemProps {
    pathname?: string;
    item: HeaderTabItem & {
        freshCount?: number;
    };
    isMainMenu?: boolean; // Логика отображения главного меню в мобиле несколько отличается от меню авторизованного пользователя

    isOpenByDefault: boolean; // Раскрывать ли пункт меню в начальном состоянии
    onClick?: () => void;
}

export const MenuLink: React.FC<MenuItemProps> = ({ item, pathname, isMainMenu, onClick, isOpenByDefault }) => {
    if (item.dropdownMenu) {
        return (
            <DropdownMenu
                item={item}
                pathname={pathname}
                isMainMenu={isMainMenu}
                onSubItemClick={onClick}
                isOpenByDefault={isOpenByDefault}
            />
        );
    }

    return <MenuItem item={item} pathname={pathname} isMainMenu={isMainMenu} onClick={onClick} />;
};
